var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4d4c4d",
  d: "M31.627 39.108H8.372a7.48 7.48 0 0 1-7.48-7.48V8.371a7.48 7.48 0 0 1 7.48-7.48h23.255a7.48 7.48 0 0 1 7.481 7.48v23.255a7.48 7.48 0 0 1-7.48 7.481"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 25.676a5.942 5.942 0 1 1 .001-11.884A5.942 5.942 0 0 1 20 25.676m7.589-6.79a7.635 7.635 0 0 0-6.74-6.74v-1.749h-1.698v1.75a7.635 7.635 0 0 0-6.74 6.74h-1.748v1.697h1.748c.391 3.54 3.2 6.35 6.74 6.74v1.749h1.698v-1.75a7.63 7.63 0 0 0 6.74-6.74h1.748v-1.696z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.407 19.735a4.408 4.408 0 1 1-8.816 0 4.408 4.408 0 0 1 8.816 0"
}))));
export default SvgLocation;